import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import SanitizedHtml from "../../components/SanitizedHtml";
import { setSubControlsDisabled, toggleSubControls } from "../subControls";
import hasRenderableControl from "../hasRenderableControl";
import buildControl from "../buildControl";

const buildMultiChoiceDropdownQuestion = (question) => {
  return (
    <>
      {question.Options?.length > 0 && (
        <Form.Control
          name={question.Name}
          as="select"
          required={question.IsMandatory}
          defaultValue=""
          onChange={(event) => {
            const selectedName = event.target.value;

            question.Options.forEach((opt) => {
              const otherId = `sub_${question.Name}_${opt.Name}`;
              toggleSubControls(otherId, opt.Name === selectedName);
            });
          }}
        >
          <option value="" disabled>
            -- Select an option --
          </option>
          {question.Options &&
            question.Options.map((o, i) => {
              return (
                <option key={i} value={o.Name}>
                  {o.Label}
                </option>
              );
            })}
        </Form.Control>
      )}

      {/* Sub-controls for all options, rendered after the dropdown */}
      {question.Options &&
        question.Options.map((o, i) => {
          const subControlsId = `sub_${question.Name}_${o.Name}`;
          return (
            o.Questions && (
              <div
                key={i}
                id={subControlsId}
                className="ms-4 mt-2"
                style={{ display: "none" }}
                ref={(el) => setSubControlsDisabled(el, true)}
              >
                {o.Questions.map((subQuestion, si) =>
                  hasRenderableControl(subQuestion) ? (
                    <Card className="mb-3" key={si}>
                      <Card.Body>
                        <Card.Title as="div">
                          <div className="d-flex align-items-start">
                            {subQuestion.IsMandatory && (
                              <span className="text-danger me-1">*</span>
                            )}

                            <SanitizedHtml
                              html={subQuestion.MainText}
                              className="question-main-text"
                            />
                          </div>
                        </Card.Title>

                        <SanitizedHtml
                          html={subQuestion.Description}
                          className="card-text question-description"
                        />
                        <Form.Group
                          className="mb-3"
                          data-error-text={subQuestion.ErrorText || ""}
                        >
                          {buildControl(subQuestion)}
                        </Form.Group>
                      </Card.Body>
                    </Card>
                  ) : null,
                )}
              </div>
            )
          );
        })}

      {question.AddOther && (
        <Form.Control
          type="text"
          name={`${question.Name}_other`}
          placeholder="Please specify"
          className="mt-2"
        />
      )}
    </>
  );
};

export default buildMultiChoiceDropdownQuestion;
